import { useEffect } from 'react';

function useScrollRestoration() {
  useEffect(() => {
    document.documentElement.scrollTo({
      top: 0,
      left: 0,
    });
  }, []);

  return null;
}

export default useScrollRestoration;
